module.exports = __webpack_public_path__ + "6f34467d369a2debc3f379a499d274de.pdf";